export default __webpack_public_path__ + "static/media/info-grass-texture.2a84956a.jpg";